import { SITES } from '../data/enums';

export { isMshops as isMshopsBU } from './isMshops';

export const isCrossBorderTradeBU = (siteId) => (
  siteId.toUpperCase() === SITES.CBT
);
